import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'reputationPrizesTextarea',
        'saveButton',
        'errorContainer',
        'charCounter',
    ];

    openModal(data) {
        $(this.reputationPrizesTextareaTarget).summernote({
            height: 96,
            toolbar: [
                ['style', ['bold', 'italic']],
                ['para', ['ul', 'ol']],
                ['toggleEditor'],
            ],
            tooltip: false,
            disableResizeEditor: true,
            placeholder: translations['job_offer.placeholder.reputation_prizes'],
            callbacks: {
                onKeyup: () => this._updateCounter(),
                onPaste: () => setTimeout(() => this._updateCounter(), 100),
            },
        });

        if (data.trim().length > 0) {
            $(this.reputationPrizesTextareaTarget).summernote('code', data);
            this._updateCounter();
        }

        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });
    }

    _updateCounter() {
        const textLength = $(this.reputationPrizesTextareaTarget).next('.note-editor').find('.note-editable').text().length;

        if (textLength > 0) {
            this.charCounterTarget.style.display = 'block';
            this.charCounterTarget.textContent = textLength + ' / 4000';
        } else {
            this.charCounterTarget.style.display = 'none';
        }

        if (textLength > 4000) {
            this.charCounterTarget.classList.add('text-danger');
            this.charCounterTarget.classList.remove('text-muted');
        } else {
            this.charCounterTarget.classList.remove('text-danger');
            this.charCounterTarget.classList.add('text-muted');
        }
    }

    save() {
        const content = $(this.reputationPrizesTextareaTarget).summernote('code');
        const textLength = $(this.reputationPrizesTextareaTarget).next('.note-editor').find('.note-editable').text().length;

        if (textLength > 4000) {
            this.errorContainerTarget.style.display = 'block';
            return;
        }

        this.errorContainerTarget.style.display = 'none';
        showPreloader();

        $.ajax({
            method: 'POST',
            url: routes['app_profile_reputationprizesfieldupdate'],
            data: { reputation_prizes: content },
            success: (response) => {
                if (response.status) {
                    $(this.element).modal('hide');

                    $('#reputation-prizes-textarea-readonly').next('.note-editor').find('.note-editable').html(response.reputation_prizes);
                    $('#reputation-prizes-textarea-readonly').html(response.reputation_prizes);

                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'profile_reputation_prizes_modification',
                            'label': '',
                        },
                    });

                    window.location.reload();
                } else {
                    hidePreloader();
                    addAlert('danger', response.message ?? translations['profile.An unknown error occurred.']);
                }
            },
            error: function(error) {
                hidePreloader();
                const json = error.responseJSON;
                addAlert('danger', json?.message ?? translations['profile.An unknown error occurred.']);
            },
        });
    }
}
